import { Box } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

export const DisabledOverlay = styled(Box)`
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.57;
  z-index: 20;
  ${css({
    backgroundColor: "primary-white",
  })}
`;
